import BreadcrumbHelper from 'general/components/CustomBreadcrumb/BreadcrumbHelper';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useGetMenuItemsList from '../MenuItemsList';
import SidebarHelper from '../SidebarHelper';
import './style2.scss';

function KT01Sidebar(props) {
  // MARK: --- Params ---
  const { t } = useTranslation();
  const router = useRouter();
  const { user, agencyRoleList, permissionList } = useSelector((state) => state.auth);
  const config = useSelector((state) => state.app.appConfig?.config);
  const poaUserId = _.find(config, (item) => item.key === 'poaUserId')?.value;
  const pathName = router.pathname;
  const menuItems = useGetMenuItemsList(user, poaUserId, agencyRoleList);

  const filterMenuItems = (menuItems, whitelistRoutes) => {
    return menuItems
      ?.map((item) => {
        const filteredSubMenuItems =
          item.subMenuItems?.filter((subItem) => {
            const subPath = subItem.path;
            return whitelistRoutes.some((route) => {
              if (!subPath) return false;
              if (subPath === route) return true;
              if (subPath.startsWith(route + '/')) {
                const idPart = subPath.slice(route.length + 1);
                return /^\d+$/.test(idPart);
              }
              return false;
            });
          }) || [];

        const itemPath = item.path;
        const isMainPathAllowed = whitelistRoutes.some((route) => {
          if (!itemPath) return false;
          if (itemPath === route) return true;
          if (itemPath.startsWith(route + '/')) {
            const idPart = itemPath.slice(route.length + 1);
            return /^\d+$/.test(idPart);
          }
          return false;
        });
        const isSubMenuPathAllowed = filteredSubMenuItems.length > 0;

        if (isMainPathAllowed || isSubMenuPathAllowed) {
          return {
            ...item,
            subMenuItems: filteredSubMenuItems,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const filteredMenuItems = useMemo(() => {
    let items = menuItems;
    let formattedItems = menuItems;
    if (!_.isEmpty(user)) {
      let whitelistRoutes = [];
      const role = user?.role;

      // if (role === AppConstants.userRole.agency) {
      //   whitelistRoutes = [
      //     ...new Set(
      //       agencyRoleList.flatMap(
      //         (agencyRole) => AppConstants.userRoleRouteWhiteList[role]?.[agencyRole] || []
      //       )
      //     ),
      //   ];
      // } else {
      //   whitelistRoutes = AppConstants.userRoleRouteWhiteList[role] || [];
      // }

      // items = filterMenuItems(menuItems, whitelistRoutes);
      formattedItems = SidebarHelper.checkPermissionList(menuItems, permissionList);
    }
    return formattedItems;
  }, [menuItems, user, agencyRoleList]);

  // MARK: --- Hooks ---
  useEffect(() => {
    // Init Aside
    if (KTLayoutAside !== undefined) {
      KTLayoutAside.init('kt_aside');
    }

    // Init Aside Toggle
    if (KTLayoutAsideToggle !== undefined) {
      KTLayoutAsideToggle.init('kt_aside_toggle');
    }

    // Init Aside Menu
    if (KTLayoutAsideMenu !== undefined) {
      KTLayoutAsideMenu.init('kt_aside_menu');
    }
  }, []);

  return (
    <div className="aside aside-left aside-fixed d-flex flex-column flex-row-auto" id="kt_aside">
      {/* Aside Header */}
      <div className="brand d-flex align-items-center px-6">
        {/* logo */}
        <a
          href="#"
          className="brand-logo"
          onClick={(e) => {
            e.preventDefault();
            if (user?.role === 'ADMIN' || (user?.role === 'AGENCY' && !user?.agency?.parentAgencyId)) {
              router.navigate(AppRoute.superDashboard);
            }
          }}
        >
          <img className="h-27px" src={AppResource.icons.tmt.tmtLogoDark} alt="logo" />
        </a>
        {/* button toggle */}
        <button
          className="h-100 brand-toggle btn btn-sm px-0 d-flex justify-content-end "
          id="kt_aside_toggle"
        >
          <span className="h-100 d-flex align-items-center svg-icon svg-icon-xl mr-0">
            <img src={AppResource.icons.tmt.toggleRight} alt="toggle" />
          </span>
        </button>
      </div>

      {/* Aside Menu */}
      <div
        id="kt_aside_menu"
        className="aside-menu my-4"
        data-menu-scroll="1"
        data-menu-vertical="1"
      // data-menu-dropdown-timeout='500'
      >
        {/* Nav menu */}
        <ul className="menu-nav">
          {filteredMenuItems?.map((item, index) => {
            if (item?.type === 'item' && (item?.show === undefined || item?.show)) {
              const hasSubMenuLV1Items =
                item?.subMenuItems !== undefined && item?.subMenuItems?.length > 0;
              return (
                <li
                  key={index}
                  className={`menu-item ${hasSubMenuLV1Items && 'menu-item-submenu'} ${hasSubMenuLV1Items &&
                    item.path?.length > 0 &&
                    pathName.includes(item.path) &&
                    'menu-item-open'
                    } ${
                    // !hasSubMenuLV1Items &&
                    item.path?.length > 0 &&
                      pathName.startsWith(item.path) &&
                      !!pathName.substring(item.path.length).match(/^(|\/\d.*|\/add.*|\/edit.*)$/)
                      ? 'menu-item-active'
                      : ''
                    }
                     ${item?.subMenuItems?.some(
                      (subItemLV1) =>
                        subItemLV1.path?.length > 0 && pathName.includes(subItemLV1.path)
                    )
                      ? 'menu-item-open'
                      : ''
                    }
                    `}
                >
                  <Link
                    to={item?.path}
                    className={`menu-link ${hasSubMenuLV1Items && 'menu-toggle'}`}
                    onClick={() => {
                      localStorage.removeItem('breadcrumPath');

                      if (!!item?.breadcrumPath) {
                        BreadcrumbHelper.setBreadcrumPath(item?.breadcrumPath, item?.path);
                      }
                    }}
                  >
                    <span className="svg-icon menu-icon">
                      <i className={`${item?.icon} w-20px`} style={{ color: '#DBDFF1' }} />
                    </span>
                    <span style={{ fontSize: 15, fontWeight: 600 }} className="menu-text">
                      {item?.text}
                    </span>
                    {item?.label && (
                      <span className="menu-label">
                        <span className="label label-rounded label-danger label-inline">
                          {item?.label}
                        </span>
                      </span>
                    )}
                    {hasSubMenuLV1Items && <i className="menu-arrow" />}
                  </Link>
                  {/* Sub menu items level 1 */}
                  {hasSubMenuLV1Items && (
                    <div className="menu-submenu">
                      <ul className="menu-subnav">
                        {item?.subMenuItems?.map((subItemLV1, subIndexLV1) => {
                          if (subItemLV1?.show === undefined || subItemLV1?.show) {
                            const hasSubMenuLV2Items =
                              subItemLV1?.subMenuItems !== undefined &&
                              subItemLV1?.subMenuItems?.length > 0;
                            return (
                              <li
                                key={subIndexLV1}
                                className={`menu-item ${hasSubMenuLV2Items && 'menu-item-submenu'} ${hasSubMenuLV2Items &&
                                  subItemLV1.path?.length > 0 &&
                                  pathName.includes(subItemLV1.path) &&
                                  'menu-item-open'
                                  } ${
                                  // !hasSubMenuLV2Items &&
                                  subItemLV1.path?.length > 0 &&
                                    pathName.startsWith(subItemLV1.path) &&
                                    !!pathName.substring(subItemLV1.path.length).match(/^(|\/\d.*|\/add.*|\/edit.*)$/)
                                    ? 'menu-item-active'
                                    : ''
                                  }
                                 ${subItemLV1?.subMenuItems?.some(
                                    (subItemLV2) =>
                                      subItemLV2.path?.length > 0 &&
                                      pathName.includes(subItemLV2.path)
                                  )
                                    ? 'menu-item-open'
                                    : ''
                                  }
                                `}
                              >
                                <Link
                                  className={`menu-link ${hasSubMenuLV2Items && 'menu-toggle'}`}
                                  to={subItemLV1?.path}
                                  onClick={() => {
                                    localStorage.removeItem('breadcrumPath');
                                    if (!!subItemLV1?.breadcrumPath) {
                                      BreadcrumbHelper.setBreadcrumPath(
                                        subItemLV1?.breadcrumPath,
                                        subItemLV1?.path
                                      );
                                    }
                                  }}
                                >
                                  <i className="menu-bullet menu-bullet-dot">
                                    <span className="bg-white"></span>
                                  </i>
                                  <span
                                    style={{ fontSize: 14, fontWeight: 600 }}
                                    className="menu-text"
                                  >
                                    {subItemLV1?.text}
                                  </span>
                                  {subItemLV1?.label && (
                                    <span className="menu-label">
                                      <span className="label label-rounded label-danger label-inline">
                                        {subItemLV1?.label}
                                      </span>
                                    </span>
                                  )}
                                  {hasSubMenuLV2Items && <i className="menu-arrow" />}
                                </Link>
                                {/* Sub menu items level 2 */}
                                {hasSubMenuLV2Items && (
                                  <div className="menu-submenu">
                                    <ul className="menu-subnav">
                                      {subItemLV1?.subMenuItems?.map((subItemLV2, subIndexLV2) => {
                                        if (subItemLV2?.show === undefined || subItemLV2?.show) {
                                          const hasSubMenuLV3Items =
                                            subItemLV2?.subMenuItems !== undefined &&
                                            subItemLV2?.subMenuItems?.length > 0;

                                          return (
                                            <li
                                              key={subIndexLV2}
                                              className={`menu-item ${hasSubMenuLV3Items && 'menu-item-submenu'
                                                } ${hasSubMenuLV3Items &&
                                                subItemLV2.path?.length > 0 &&
                                                pathName.includes(subItemLV2.path) &&
                                                'menu-item-open'
                                                } ${
                                                // !hasSubMenuLV3Items &&
                                                subItemLV2.path?.length > 0 &&
                                                  pathName.startsWith(subItemLV2.path) &&
                                                  !!pathName.substring(subItemLV2.path.length).match(/^(|\/\d.*|\/add.*|\/edit.*)$/)
                                                  ? 'menu-item-active'
                                                  : ''
                                                }
                                             ${subItemLV2?.subMenuItems?.some(
                                                  (subItemLV3) =>
                                                    subItemLV3.path?.length > 0 &&
                                                    pathName.includes(subItemLV3.path)
                                                )
                                                  ? 'menu-item-open'
                                                  : ''
                                                }
                                            `}
                                            >
                                              <Link
                                                className={`menu-link rounded-0 ${hasSubMenuLV3Items && 'menu-toggle'
                                                  }`}
                                                to={subItemLV2?.path}
                                                onClick={() => {
                                                  localStorage.removeItem('breadcrumPath');
                                                  if (!!subItemLV2?.breadcrumPath) {
                                                    BreadcrumbHelper.setBreadcrumPath(
                                                      subItemLV2?.breadcrumPath,
                                                      subItemLV2?.path
                                                    );
                                                  }
                                                }}
                                              >
                                                <i className="menu-bullet menu-bullet-dot">
                                                  <span></span>
                                                </i>
                                                <span
                                                  style={{ fontSize: 14, fontWeight: 600 }}
                                                  className="menu-text"
                                                >
                                                  {subItemLV2?.text}
                                                </span>
                                                {subItemLV2?.label && (
                                                  <span className="menu-label">
                                                    <span className="label label-rounded label-danger label-inline">
                                                      {subItemLV2?.label}
                                                    </span>
                                                  </span>
                                                )}
                                                {hasSubMenuLV3Items && <i className="menu-arrow" />}
                                              </Link>
                                              {/* Sub menu items level 3 */}
                                              {hasSubMenuLV3Items && (
                                                <div className="menu-submenu">
                                                  <ul className="menu-subnav">
                                                    {subItemLV2?.subMenuItems?.map(
                                                      (subItemLV3, subIndexLV3) => {
                                                        if (subItemLV3?.show === undefined || subItemLV3?.show) {
                                                          const hasSubMenuLV4Items =
                                                            subItemLV3?.subMenuItems !== undefined &&
                                                            subItemLV3?.subMenuItems?.length > 0;

                                                          return (
                                                            <li
                                                              key={subIndexLV3}
                                                              className={`menu-item ${hasSubMenuLV4Items && 'menu-item-submenu'
                                                                } ${hasSubMenuLV4Items &&
                                                                subItemLV3.path?.length > 0 &&
                                                                pathName.includes(subItemLV3.path) &&
                                                                'menu-item-open'
                                                                } ${
                                                                //   !hasSubMenuLV4Items &&
                                                                subItemLV3.path?.length > 0 &&
                                                                  pathName.startsWith(subItemLV3.path) &&
                                                                  !!pathName.substring(subItemLV3.path.length).match(/^(|\/\d.*|\/add.*|\/edit.*)$/)
                                                                  ? 'menu-item-active'
                                                                  : ''
                                                                }
                                                           ${subItemLV3?.subMenuItems?.some(
                                                                  (subItemLV4) =>
                                                                    subItemLV4.path?.length > 0 &&
                                                                    pathName.includes(subItemLV4.path)
                                                                )
                                                                  ? 'menu-item-open'
                                                                  : ''
                                                                }
                                                          `}
                                                            >
                                                              <Link
                                                                className={`menu-link rounded-0 ${hasSubMenuLV4Items && 'menu-toggle'
                                                                  }`}
                                                                to={subItemLV3?.path}
                                                                onClick={() => {
                                                                  localStorage.removeItem(
                                                                    'breadcrumPath'
                                                                  );
                                                                  if (!!subItemLV3?.breadcrumPath) {
                                                                    BreadcrumbHelper.setBreadcrumPath(
                                                                      subItemLV3?.breadcrumPath,
                                                                      subItemLV3?.path
                                                                    );
                                                                  }
                                                                }}
                                                              >
                                                                <i className="menu-bullet menu-bullet-dot">
                                                                  <span></span>
                                                                </i>
                                                                <span
                                                                  style={{
                                                                    fontSize: 14,
                                                                    fontWeight: 600,
                                                                  }}
                                                                  className="menu-text"
                                                                >
                                                                  {subItemLV3?.text}
                                                                </span>
                                                                {subItemLV3?.label && (
                                                                  <span className="menu-label">
                                                                    <span className="label label-rounded label-danger label-inline">
                                                                      {subItemLV3?.label}
                                                                    </span>
                                                                  </span>
                                                                )}
                                                                {hasSubMenuLV4Items && (
                                                                  <i className="menu-arrow" />
                                                                )}
                                                              </Link>
                                                            </li>
                                                          );
                                                        }
                                                      }
                                                    )}
                                                  </ul>
                                                </div>
                                              )}
                                            </li>
                                          );
                                        }
                                      })}
                                    </ul>
                                  </div>
                                )}
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  )}
                </li>
              );
            }

            // Section
            if (item?.type === 'section' && (item?.show === undefined || item?.show)) {
              return (
                <li key={index} className={`menu-section ${index === 0 ? 'm-0' : ''}`}>
                  <h4 style={{ fontSize: 12, fontWeight: 600 }} className="menu-text">
                    {item?.text}
                  </h4>
                </li>
              );
            }
          })}
        </ul>
      </div>
      <div
        style={{
          backgroundImage: `url(${AppResource.images.tmt.bgSideBar})`,
          height: '100vh',
          width: '100%',
          position: 'absolute',
          bottom: '0',
          left: '0',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: -1,
        }}
      />
    </div>
  );
}

export default KT01Sidebar;
